import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {EntityKey} from '../entity/entity';
import {Observable} from 'rxjs';
import {SingleEntityLineProcessing} from '../entity/single-entity-line-processing';

@Service()
export class SingleEntityLineProcessingService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getEntitySingleEntityLineProcessingRecords(entityKey: EntityKey): Observable<SingleEntityLineProcessing[]> {
    const url = this.urlBase + 'selprocessing/entity/' + entityKey.entityId + '/' + entityKey.entityRevision;
    return this.http.get<SingleEntityLineProcessing[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
